import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";
import type {
  ChartOfAccountDto,
  ChartOfAccountFilter,
} from "@/features/ledger/api/dto";

/**
 * Plan de comptes paginé (`POST /ChartOfAccounts/all`, guide §4.2) —
 * les comptes de commission sont identifiés par `isCommissionAccount`
 * et ventilés par ligne de métier.
 */
export const useChartOfAccounts = (
  params: ListRequest<ChartOfAccountFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.LEDGER_CHART_OF_ACCOUNTS_LIST(params),
    queryFn: () =>
      mutateData({
        url: ledgerEndpoints.chartOfAccounts.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<ChartOfAccountDto>>,
    enabled,
  });
